// Carries the username chosen at signup to onboarding for the same account.
// Signup's profile write can still be in flight (or have failed) when the
// onboarding screen appears, so onboarding sends the name with its request and
// the backend uses it only if it has to create the missing profile.
// Session storage keeps it to this tab; it is keyed by account so a switched
// account never picks up another person's name.

const keyFor = (uid) => `studyden.pendingUsername.${uid}`;

export const validUsername = (value) => {
  if (typeof value !== "string") return "";
  const name = value.trim();
  const hasControlCharacter = [...name].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127);
  return name.length > 0 && name.length <= 100 && !hasControlCharacter ? name : "";
};

export function rememberPendingUsername(uid, username) {
  const name = validUsername(username);
  if (!uid || !name) return;
  try { window.sessionStorage.setItem(keyFor(uid), name); } catch (_error) { /* storage unavailable */ }
}

export function readPendingUsername(uid) {
  if (!uid) return "";
  try { return validUsername(window.sessionStorage.getItem(keyFor(uid)) || ""); } catch (_error) { return ""; }
}

export function clearPendingUsername(uid) {
  if (!uid) return;
  try { window.sessionStorage.removeItem(keyFor(uid)); } catch (_error) { /* storage unavailable */ }
}
